import { render, staticRenderFns } from "./KifuControll.vue?vue&type=template&id=0590864b&scoped=true&"
import script from "./KifuControll.vue?vue&type=script&lang=js&"
export * from "./KifuControll.vue?vue&type=script&lang=js&"
import style0 from "./KifuControll.vue?vue&type=style&index=0&id=0590864b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0590864b",
  null
  
)

export default component.exports